type RoundingMode = 'round' | 'floor' | 'ceil';
type Precision = number | 'auto';

const ROUNDING_FN: Record<RoundingMode, (x: number) => number> = {
    round: Math.round,
    floor: Math.floor,
    ceil: Math.ceil,
};

/**
 * Rounds a number to a given precision.
 *
 * - Explicit precision: rounds to the nearest multiple of `precision`
 *   (e.g. precision=100 → 1523 becomes 1500)
 * - 'auto': precision is determined automatically based on the number's magnitude,
 *   using the geometric midpoint of each logarithmic decade (√10 ≈ 3.162).
 *   Minimum auto-precision is 10. Examples: 7→10, 712→700, 4312→4000
 */
export const roundWithPrecision = (value: number, precision: Precision, mode: RoundingMode = 'round'): number => {
    if (value <= 0) {
        return 0;
    }

    const p = precision === 'auto' ? Math.max(10, 10 ** Math.floor(Math.log10(value) - 0.5)) : precision;

    return ROUNDING_FN[mode](value / p) * p;
};
